import { Component, OnInit } from '@angular/core';
import { apiService } from '../../../../../service/api.service';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-confirmar',
  templateUrl: './modal-confirmar.component.html',
  styleUrls: ['./modal-confirmar.component.css']
})
export class ModalConfirmarComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmarComponent>,
    public api:apiService
  ) { }

  ngOnInit(): void {
  }

  confirmar(){
    this.api.API_POST_finalizarAutoEvaluacion().subscribe((response) => {    
      this.onNoClick();
    },
    (err) => {
      this.onNoClick();
      console.log(err)
    }) 
  }


  onNoClick(){
    this.dialogRef.close();
  }
}
